export default function stringToStyles( string = '' ){

    if( string.length ){
        const tag = document.createElement('style')
        tag.setAttribute('type', 'text/css')
        tag.appendChild( document.createTextNode( string ) )
        document.head.appendChild( tag )
    }


}
